import { PageIdentityProvider } from '@athena/ui'
import type { ReactNode } from 'react'

/**
 * The product's page identity: every page names itself with `usePageTitle`,
 * the shell draws that name as the page's one `h1`, and the document title is
 * "Page · Athena". The shared mechanism lives in `@athena/ui`
 * (`lib/page-identity.tsx`), where the admin app mounts the same one with its
 * own suffix.
 */
export { useCurrentPageTitle, usePageTitle } from '@athena/ui'

/**
 * "Athena" is the product's name, the same in both languages, so the suffix
 * is not a translated string.
 */
export function PageTitleProvider({ children }: { children: ReactNode }) {
  return <PageIdentityProvider suffix="Athena">{children}</PageIdentityProvider>
}
